import { UsersApiService } from './crm/UsersApiService.js';
import { setRoleMetadata } from '../constants/Roles.js';

let _loadPromise = null;

export class RoleMetadataService {
    static async ensureLoaded() {
        if (_loadPromise) return _loadPromise;
        _loadPromise = (async () => {
            try {
                const res = await UsersApiService.listRoles();
                const roles = res?.data ?? res ?? [];
                setRoleMetadata(Array.isArray(roles) ? roles : []);
            } catch (e) {
                console.warn('[RoleMetadataService] Could not load roles:', e);
            }
        })();
        return _loadPromise;
    }
}
